import React, { FC, createContext, useState, useContext } from "react";

import { TeamContext } from "../context";

import { ICard } from "../interfaces";
import { Phase } from "../util/enums";

interface ICardContext {
    solutionCards: ICard[] | [];
    draggableCard?: ICard;
    isDragging: boolean,
    isStrengthCardCurrentlyDragged: boolean;
    currentSolutionCardWidth: number,
    currentlyChoosenCard: any;
    solutionCardThatNeedsToFlip: any;
    currentlyHoveredStrengthCard: ICard | undefined,
    isStrengthCardHoveredWhileSolutionIsDragged: ICard | undefined, 
    isExchangeButtonOnActionHovered: boolean, 
    dataOfDoubleClickedSolutionCard: any | undefined, 
    threeActions: any, 
    drawSolutionCard(card: ICard): void;
    setDraggableCard(card?: ICard): void;
    setIsDragging(state: boolean): void;
    setIsStrengthCardCurrentlyDragged(isStrengthCardCurrentlyDragged: boolean): void;
    setCurrentSolutionCardWidth(currentSolutionCardWidth: number): void;
    setCurrentlyChoosenCard(currentlyChoosenCard: any): void;
    flipSolutionCardBySelectedType(solutionCardTypeThatNeedsToFlip: string): void;
    setCurrentlyHoveredStrengthCard(currentlyHoveredStrengthCard: ICard | undefined): void;
    setIsStrengthCardHoveredWhileSolutionIsDragged(isStrengthCardHoveredWhileSolutionIsDragged: ICard | undefined): void;
    setIsExchangeButtonOnActionHovered(isExchangeButtonOnActionHovered: boolean): void;
    setDataOfDoubleClickedSolutionCard(dataOfDoubleClickedSolutionCard: any | undefined): void;
    setThreeActions(threeActions: any): void;
}

const CardContext = createContext({} as ICardContext);

interface CardContextProps {
    children: React.ReactNode;
}

const CardContextProvider: FC<CardContextProps> = (props) => {
    const { game } = useContext(TeamContext);

    const [solutionCards, setSolutionCards] = useState<ICard[] | []>([]);
    const [draggableCard, setDraggableCard] = useState<ICard>();
    const [isDragging, setIsDragging] = useState(false);
    const [isStrengthCardCurrentlyDragged, setIsStrengthCardCurrentlyDragged] = useState<boolean>(false);
    const [currentSolutionCardWidth, setCurrentSolutionCardWidth] = useState<number>(0);
    const [currentlyChoosenCard, setCurrentlyChoosenCard] = useState<any>();
    const [solutionCardThatNeedsToFlip, setSolutionCardThatNeedsToFlip] = useState<any>({
        emotional: false,
        social: false,
        mental: false,
        physical: false
    });
    const [currentlyHoveredStrengthCard, setCurrentlyHoveredStrengthCard] = useState<ICard | undefined>();
    const [isStrengthCardHoveredWhileSolutionIsDragged, setIsStrengthCardHoveredWhileSolutionIsDragged] = useState<ICard | undefined>(undefined);
    const [isExchangeButtonOnActionHovered, setIsExchangeButtonOnActionHovered] = useState<boolean>(false);
    const [dataOfDoubleClickedSolutionCard, setDataOfDoubleClickedSolutionCard] = useState<any | undefined>(undefined);
    const [threeActions, setThreeActions] = useState({
        first: "",
        second: "",
        third: ""
    });

    const drawSolutionCard = (card: ICard) => {
        setSolutionCards([...solutionCards, card]);
    };

    const flipSolutionCardBySelectedType = (solutionCardTypeThatNeedsToFlip: string) => {
         if (game?.phase === Phase.QUESTION_CARD) {
            switch (solutionCardTypeThatNeedsToFlip) {
                case "emotional": {
                    setTimeout(() => {
                        setSolutionCardThatNeedsToFlip({ ...solutionCardThatNeedsToFlip, emotional: false });
                    }, 10);
                    setSolutionCardThatNeedsToFlip({ ...solutionCardThatNeedsToFlip, emotional: true });
                    return;
                }
                case "social": {
                    setTimeout(() => {
                        setSolutionCardThatNeedsToFlip({ ...solutionCardThatNeedsToFlip, social: false });
                    }, 10);
                    setSolutionCardThatNeedsToFlip({ ...solutionCardThatNeedsToFlip, social: true });
                    return;
                }
                case "mental": {
                    setTimeout(() => {
                        setSolutionCardThatNeedsToFlip({ ...solutionCardThatNeedsToFlip, mental: false });
                    }, 10);
                    setSolutionCardThatNeedsToFlip({ ...solutionCardThatNeedsToFlip, mental: true });
                    return;
                }
                case "physical": {
                    setTimeout(() => {
                        setSolutionCardThatNeedsToFlip({ ...solutionCardThatNeedsToFlip, physical: false });
                    }, 10);
                    setSolutionCardThatNeedsToFlip({ ...solutionCardThatNeedsToFlip, physical: true });
                    return;
                }
            }
        }

    }


    const providerValue = {
        solutionCards,
        draggableCard,
        isDragging,
        isStrengthCardCurrentlyDragged,
        currentSolutionCardWidth,
        currentlyChoosenCard,
        solutionCardThatNeedsToFlip,
        currentlyHoveredStrengthCard,
        isStrengthCardHoveredWhileSolutionIsDragged, 
        isExchangeButtonOnActionHovered, 
        dataOfDoubleClickedSolutionCard, 
        threeActions, 
        drawSolutionCard,
        setDraggableCard,
        setIsDragging,
        setIsStrengthCardCurrentlyDragged,
        setCurrentSolutionCardWidth,
        setCurrentlyChoosenCard,
        flipSolutionCardBySelectedType,
        setCurrentlyHoveredStrengthCard,
        setIsStrengthCardHoveredWhileSolutionIsDragged,
        setIsExchangeButtonOnActionHovered,
        setDataOfDoubleClickedSolutionCard,
        setThreeActions
    };

    return (
        <CardContext.Provider value={providerValue}>
            {props.children}
        </CardContext.Provider>
    );
}

export { CardContext, CardContextProvider };